export class ItemBrand {
  id: number;
  name: string;
}
